import { render, staticRenderFns } from "./FormRecordInput.vue?vue&type=template&id=046ffd8a&scoped=true&"
import script from "./FormRecordInput.vue?vue&type=script&lang=js&"
export * from "./FormRecordInput.vue?vue&type=script&lang=js&"
import style0 from "./FormRecordInput.vue?vue&type=style&index=0&id=046ffd8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046ffd8a",
  null
  
)

export default component.exports